import { useState } from 'react';
import { Field, Label, Switch } from '@headlessui/react';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function ContactUs() {
  const [agreed, setAgreed] = useState(false);

  return (
    <div className="bg-gradient-to-b from-blue-900/20 to-transparent isolate px-6 py-24 sm:py-32 lg:px-8 text-white">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-4xl font-extrabold tracking-tight sm:text-5xl">Contact Sales</h2>
        <p className="mt-4 text-lg text-white0">
          Want to get in touch? We'd love to hear from you. Fill in the form and our team will get back to you within 6–8 hours.
        </p>
      </div>

      <form action="#" method="POST" className="mx-auto mt-16 max-w-xl sm:mt-20">
        <div className="grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2">
          <div>
            <label htmlFor="first-name" className="block text-sm font-medium text-white">First name</label>
            <input
              type="text"
              name="first-name"
              id="first-name"
              autoComplete="given-name"
              className="mt-2 block w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-black placeholder-gray-400 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div>
            <label htmlFor="last-name" className="block text-sm font-medium text-white">Last name</label>
            <input
              type="text"
              name="last-name"
              id="last-name"
              autoComplete="family-name"
              className="mt-2 block w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-black placeholder-gray-400 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div className="sm:col-span-2">
            <label htmlFor="company" className="block text-sm font-medium text-white">Company</label>
            <input
              type="text"
              name="company"
              id="company"
              autoComplete="organization"
              className="mt-2 block w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-black placeholder-gray-400 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div className="sm:col-span-2">
            <label htmlFor="email" className="block text-sm font-medium text-white">Email</label>
            <input
              type="email"
              name="email"
              id="email"
              autoComplete="email"
              className="mt-2 block w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-black placeholder-gray-400 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div className="sm:col-span-2">
            <label htmlFor="phone-number" className="block text-sm font-medium text-white">Phone number</label>
            <div className="relative mt-2 flex rounded-lg shadow-sm">
              <select
                id="country"
                name="country"
                className="rounded-l-lg border border-r-0 border-gray-300 bg-gray-100 px-3 py-2 text-sm text-black focus:border-indigo-500 focus:ring-indigo-500"
              >
                <option>ZA</option>
                <option>US</option>
                <option>CA</option>
                <option>EU</option>
              </select>
              <input
                type="tel"
                name="phone-number"
                id="phone-number"
                autoComplete="tel"
                className="flex-1 rounded-r-lg border border-gray-300 bg-white px-4 py-2 text-black placeholder-gray-400 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
          </div>

          <div className="sm:col-span-2">
            <label htmlFor="message" className="block text-sm font-medium text-white">Message</label>
            <textarea
              name="message"
              id="message"
              rows={4}
              className="mt-2 block w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-black placeholder-gray-400 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              placeholder="Let us know how we can help..."
            />
          </div>

          <Field as="div" className="sm:col-span-2 mt-4 flex items-center gap-x-3">
            <Switch
              checked={agreed}
              onChange={setAgreed}
              className={classNames(
                agreed ? 'bg-indigo-600' : 'bg-gray-200',
                'relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600'
              )}
            >
              <span className="sr-only">Agree to policies</span>
              <span
                aria-hidden="true"
                className={classNames(
                  agreed ? 'translate-x-6' : 'translate-x-1',
                  'inline-block h-4 w-4 transform rounded-full bg-white transition-transform'
                )}
              />
            </Switch>
            <Label className="text-sm text-gray-600">
              I agree to the{' '}
              <a href="#" className="text-indigo-600 font-medium hover:underline">privacy policy</a>.
            </Label>
          </Field>
        </div>

        <div className="mt-10">
          <button
            type="submit"
            className="w-full rounded-lg bg-indigo-600 px-4 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-600"
          >
            Let’s Talk
          </button>
        </div>
      </form>
    </div>
  );
}


